import ChevronRightOutlined from '@icons/ChevronRightOutlined';
import { styled } from '@mui/material';
import MuiAccordionSummary, { AccordionSummaryProps, accordionSummaryClasses } from '@mui/material/AccordionSummary';

const AccordionSummary = styled((props: AccordionSummaryProps) => <MuiAccordionSummary expandIcon={<ChevronRightOutlined sx={{ fontSize: '0.9rem' }} />} {...props} />)(
  ({ theme }) => ({
    flexDirection: 'row-reverse',
    minHeight: '48px',
    padding: theme.spacing(0, 2),
    '&.Mui-expanded': {
      minHeight: '48px'
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
      width: '24px',
      height: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      transformOrigin: 'center'
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
      transform: 'rotate(90deg)'
    },
    [`& .${accordionSummaryClasses.content}`]: {
      marginLeft: theme.spacing(1),
      '&.Mui-expanded': {
        margin: `${theme.spacing(1.5, 0, 1.5, 1)}`
      }
    }
  })
);

export default AccordionSummary;
